import React from 'react'
import Modal from 'admin/components/shared/Modal'
import History from 'admin/components/History'
import useModal from '../hooks/useModal'

export default () => {
  const {itemType, itemId, popModal} = useModal()

  const handleClose = e => {
    e.preventDefault()
    popModal('history', ['itemType', 'itemId'])
  }

  if (!itemType || !itemId) return null

  const allowNotes = itemType === 'Account'

  return (
    <Modal onClose={handleClose} flashId={`${itemType.toLowerCase()}-history`} maxWidth='65%'>
      <History
        itemType={itemType}
        itemId={itemId}
        title={`History for ${itemType} ${itemId}`}
        allowNotes={allowNotes}
      />
    </Modal>
  )
}
